import { IKho } from "../../../model/respone/category/IKho"
import { generateActionTypeIds } from "../generateActionTypeIds"
import IGenericActionType from "../IGenericActionType"

export const eKhoActionTypeDefine = {
    LOAD_START: undefined,
    LOAD_SUCCESS: {} as IKho[],
    LOAD_ERROR: "",

    SHOW_EDIT_MODAL: {} as undefined | IKho,
    CLOSE_EDIT_MODAL: undefined,
    
    SAVE_START: {} as IKho,
    SAVE_SUCCESS: {} as IKho,
    SAVE_ERROR: "",

    DELETE_START: 0,
    DELETE_SUCCESS: undefined,
    DELETE_ERROR: "",


}
export const eKhoActionTypeIds = generateActionTypeIds(eKhoActionTypeDefine, "KHO")

export type IKhoActions = IGenericActionType<typeof eKhoActionTypeDefine, "KHO">